"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _title_panel = _interopRequireDefault(require("../panel/title_panel"));

var _month_panel = _interopRequireDefault(require("../panel/month_panel"));

var _year_panel = _interopRequireDefault(require("../panel/year_panel"));

var _date_panel = _interopRequireDefault(require("../panel/date_panel"));

var _week_panel = _interopRequireDefault(require("../panel/week_panel"));

var _datepicker_compact_props = _interopRequireDefault(require("../datepicker_compact_props"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var DateArea =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(DateArea, _PureComponent);

  function DateArea(props) {
    var _this;

    _classCallCheck(this, DateArea);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DateArea).call(this, props));
    var picker = props.picker;
    _this.state = {
      chooseMonth: picker === 'month',
      chooseYear: picker === 'year',
      chooseWeek: picker === 'week'
    };
    _this.handleShowChooseMonth = _this.handleShowChooseMonth.bind(_assertThisInitialized(_this));
    _this.handleShowChooseYear = _this.handleShowChooseYear.bind(_assertThisInitialized(_this));
    _this.handleYearAndMonthChange = _this.handleYearAndMonthChange.bind(_assertThisInitialized(_this));
    _this.handleYearChange = _this.handleYearChange.bind(_assertThisInitialized(_this));
    _this.handleMonthChange = _this.handleMonthChange.bind(_assertThisInitialized(_this));
    return _this;
  } // 切换选择月份


  _createClass(DateArea, [{
    key: "handleShowChooseMonth",
    value: function handleShowChooseMonth() {
      var picker = this.props.picker;

      if (picker === 'month') {
        this.setState({
          chooseMonth: !this.state.chooseMonth,
          chooseYear: !this.state.chooseYear
        });
      } else {
        this.setState({
          chooseMonth: !this.state.chooseMonth,
          chooseYear: false
        });
      }
    } // 切换选择年份

  }, {
    key: "handleShowChooseYear",
    value: function handleShowChooseYear() {
      var picker = this.props.picker;

      if (picker === 'month') {
        this.setState({
          chooseMonth: !this.state.chooseMonth,
          chooseYear: !this.state.chooseYear
        });
      } else if (picker === 'year') {
        this.setState({
          chooseMonth: false,
          chooseYear: true
        });
      } else {
        this.setState({
          chooseMonth: false,
          chooseYear: !this.state.chooseYear
        });
      }
    } // 选择展示年月回调

  }, {
    key: "handleYearAndMonthChange",
    value: function handleYearAndMonthChange(event) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _this$props = this.props,
          onYearAndMonthChange = _this$props.onYearAndMonthChange,
          type = _this$props.type;
      var year = data.year,
          month = data.month;

      if ((0, _spauiUtils.isFunction)(onYearAndMonthChange)) {
        onYearAndMonthChange(event, type, year, month);
      }
    } // 选择年份回调

  }, {
    key: "handleYearChange",
    value: function handleYearChange(event, year) {
      var _this$props2 = this.props,
          month = _this$props2.month,
          onYearAndMonthChange = _this$props2.onYearAndMonthChange,
          type = _this$props2.type,
          picker = _this$props2.picker,
          onChange = _this$props2.onChange;

      if ((0, _spauiUtils.isFunction)(onYearAndMonthChange)) {
        // 如果是年份范围的选择，年份选择完成后，面板保持不变，还是显示年份的选择，其它的则要进行切换
        if (!(picker === 'year' && (type === 'start' || type === 'end'))) {
          this.setState({
            chooseYear: false,
            chooseMonth: true
          });
        }

        onYearAndMonthChange(event, type, year, month);
      } // 如果仅仅是选择到年份，则完成选择


      if (picker === 'year' && (0, _spauiUtils.isFunction)(onChange)) {
        onChange(event, type, {
          year: year,
          month: month
        });
      }
    } // 选择月份回调

  }, {
    key: "handleMonthChange",
    value: function handleMonthChange(event, month) {
      var _this$props3 = this.props,
          year = _this$props3.year,
          onYearAndMonthChange = _this$props3.onYearAndMonthChange,
          type = _this$props3.type,
          picker = _this$props3.picker,
          onChange = _this$props3.onChange;

      if ((0, _spauiUtils.isFunction)(onYearAndMonthChange)) {
        // 如果是月份范围的选择，月份选择完成后，面板保持不变，还是显示月份的选择, 其它的则要进行切换
        if (!(picker === 'month' && (type === 'start' || type === 'end'))) {
          this.setState({
            chooseMonth: false
          });
        }

        onYearAndMonthChange(event, type, year, month);
      } // 如果是仅选择到月份，则完成选择


      if (picker === 'month' && (0, _spauiUtils.isFunction)(onChange)) {
        onChange(event, type, {
          year: year,
          month: month
        });
      }
    } // 获取月份数据

  }, {
    key: "getMonthData",
    value: function getMonthData(currentYear) {
      var _this$props4 = this.props,
          optionalStartDateData = _this$props4.optionalStartDateData,
          optionalEndDateData = _this$props4.optionalEndDateData;
      var result = [];
      var i = 0;
      var len = 11;

      if (optionalStartDateData.year === currentYear) {
        i = optionalStartDateData.month;

        if (currentYear === optionalEndDateData.year) {
          len = optionalEndDateData.month;
        }
      } else if (optionalEndDateData.year === currentYear) {
        len = optionalEndDateData.month;

        if (currentYear === optionalStartDateData.year) {
          i = optionalStartDateData.month;
        }
      }

      for (; i <= len; i++) {
        result.push(i);
      }

      return result;
    }
    /**
     * 获取 datePicker 是否有 footer
     */

  }, {
    key: "getHasFooter",
    value: function getHasFooter() {
      var _compactProps = (0, _datepicker_compact_props["default"])(this.props),
          type = _compactProps.type,
          useShortcut = _compactProps.useShortcut,
          timePicker = _compactProps.timePicker,
          hideSubmitButton = _compactProps.hideSubmitButton;

      switch (type) {
        case 'single':
          {
            if (useShortcut || timePicker) {
              return true;
            }

            return false;
          }

        case 'range':
          {
            if (useShortcut || timePicker || !hideSubmitButton || timePicker || !hideSubmitButton) {
              return true;
            }

            return false;
          }

        default:
          {
            return true;
          }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _compactProps2 = (0, _datepicker_compact_props["default"])(this.props),
          year = _compactProps2.year,
          month = _compactProps2.month,
          onChange = _compactProps2.onChange,
          startData = _compactProps2.startData,
          endData = _compactProps2.endData,
          dateData = _compactProps2.dateData,
          type = _compactProps2.type,
          htmlRef = _compactProps2.htmlRef,
          style = _compactProps2.style,
          optionalStartDateData = _compactProps2.optionalStartDateData,
          optionalEndDateData = _compactProps2.optionalEndDateData,
          shortestRange = _compactProps2.shortestRange,
          longestRange = _compactProps2.longestRange,
          startDateDisabled = _compactProps2.startDateDisabled,
          endDateDisabled = _compactProps2.endDateDisabled,
          disableDate = _compactProps2.disableDate,
          startYear = _compactProps2.startYear,
          startMonth = _compactProps2.startMonth,
          endYear = _compactProps2.endYear,
          endMonth = _compactProps2.endMonth,
          firstDayOfWeek = _compactProps2.firstDayOfWeek,
          endDayOfWeek = _compactProps2.endDayOfWeek,
          fixedTips = _compactProps2.fixedTips,
          fixedNumber = _compactProps2.fixedNumber,
          nowDateObject = _compactProps2.nowDateObject,
          _compactProps2$classN = _compactProps2.className,
          className = _compactProps2$classN === void 0 ? '' : _compactProps2$classN,
          _compactProps2$hideEn = _compactProps2.hideEndDatePanel,
          hideEndDatePanel = _compactProps2$hideEn === void 0 ? false : _compactProps2$hideEn,
          startDateCanBeUnlimited = _compactProps2.startDateCanBeUnlimited,
          endDateCanBeUnlimited = _compactProps2.endDateCanBeUnlimited,
          unlimitedDateValue = _compactProps2.unlimitedDateValue,
          unlimitedDateValueLabel = _compactProps2.unlimitedDateValueLabel,
          getDateValue = _compactProps2.getDateValue,
          format = _compactProps2.format,
          _compactProps2$classN2 = _compactProps2.classNameMap,
          classNameMap = _compactProps2$classN2 === void 0 ? {} : _compactProps2$classN2,
          panelWeekStart = _compactProps2.panelWeekStart,
          hoverYear = _compactProps2.hoverYear,
          hoverMonth = _compactProps2.hoverMonth,
          hoverDate = _compactProps2.hoverDate,
          changeHoverDate = _compactProps2.changeHoverDate,
          _compactProps2$locale = _compactProps2.locale,
          locale = _compactProps2$locale === void 0 ? {} : _compactProps2$locale,
          setLabel = _compactProps2.setLabel,
          useNewUI = _compactProps2.useNewUI,
          picker = _compactProps2.picker,
          displayedStartYear = _compactProps2.displayedStartYear,
          displayedEndYear = _compactProps2.displayedEndYear,
          onChangeDisplayedStartYear = _compactProps2.onChangeDisplayedStartYear,
          MonthPanelListComponent = _compactProps2.MonthPanelListComponent,
          YearPanelListComponent = _compactProps2.YearPanelListComponent;

      var _this$state = this.state,
          chooseMonth = _this$state.chooseMonth,
          chooseYear = _this$state.chooseYear,
          chooseWeek = _this$state.chooseWeek;
      var titlePanelDisabled = false;
      var panelComponent = null; // 如果面板对应日期禁止了，那就不能够操作了

      if (type === 'start' && startDateDisabled || type === 'end' && endDateDisabled) {
        chooseMonth = false;
        chooseYear = false;
        chooseWeek = false;
        titlePanelDisabled = true;
      } // 根据需要展示对应的面板


      if (chooseMonth) {
        panelComponent = _react["default"].createElement(_month_panel["default"], {
          PanelListComponent: MonthPanelListComponent,
          locale: locale,
          setLabel: setLabel,
          classNameMap: classNameMap,
          shortestRange: shortestRange,
          longestRange: longestRange,
          type: type,
          picker: picker,
          startYear: startYear,
          startMonth: startMonth,
          endYear: endYear,
          endMonth: endMonth,
          year: year,
          month: month,
          startData: startData,
          endData: endData,
          hideEndDatePanel: hideEndDatePanel,
          optionalStartDateData: optionalStartDateData,
          optionalEndDateData: optionalEndDateData,
          onChange: this.handleMonthChange,
          hoverYear: hoverYear,
          hoverMonth: hoverMonth,
          changeHoverDate: changeHoverDate
        });
      } else if (chooseYear) {
        panelComponent = _react["default"].createElement(_year_panel["default"], {
          PanelListComponent: YearPanelListComponent,
          locale: locale,
          setLabel: setLabel,
          classNameMap: classNameMap,
          type: type,
          picker: picker,
          displayedStartYear: displayedStartYear,
          displayedEndYear: displayedEndYear,
          startYear: startYear,
          startMonth: startMonth,
          endYear: endYear,
          endMonth: endMonth,
          year: year,
          dateData: dateData,
          month: month,
          hideEndDatePanel: hideEndDatePanel,
          optionalStartDateData: optionalStartDateData,
          optionalEndDateData: optionalEndDateData,
          onChange: this.handleYearChange
        });
      } else if (chooseWeek) {
        panelComponent = _react["default"].createElement(_week_panel["default"], {
          locale: locale,
          setLabel: setLabel,
          classNameMap: classNameMap,
          startDateCanBeUnlimited: startDateCanBeUnlimited,
          endDateCanBeUnlimited: endDateCanBeUnlimited,
          unlimitedDateValue: unlimitedDateValue,
          unlimitedDateValueLabel: unlimitedDateValueLabel,
          getDateValue: getDateValue,
          format: format,
          type: type,
          firstDayOfWeek: firstDayOfWeek,
          endDayOfWeek: endDayOfWeek,
          startYear: startYear,
          startMonth: startMonth,
          endYear: endYear,
          endMonth: endMonth,
          startDateDisabled: startDateDisabled,
          endDateDisabled: endDateDisabled,
          optionalStartDateData: optionalStartDateData,
          optionalEndDateData: optionalEndDateData,
          shortestRange: shortestRange,
          longestRange: longestRange,
          year: year,
          month: month,
          onChange: onChange,
          dateData: dateData,
          startData: startData,
          endData: endData,
          hideEndDatePanel: hideEndDatePanel,
          onYearAndMonthChange: this.handleYearAndMonthChange,
          panelWeekStart: panelWeekStart,
          hoverYear: hoverYear,
          hoverMonth: hoverMonth,
          hoverDate: hoverDate,
          fixedTips: fixedTips,
          fixedNumber: fixedNumber,
          changeHoverDate: changeHoverDate
        });
      } else {
        panelComponent = _react["default"].createElement(_date_panel["default"], {
          locale: locale,
          useNewUI: useNewUI,
          setLabel: setLabel,
          classNameMap: classNameMap,
          startDateCanBeUnlimited: startDateCanBeUnlimited,
          endDateCanBeUnlimited: endDateCanBeUnlimited,
          unlimitedDateValue: unlimitedDateValue,
          unlimitedDateValueLabel: unlimitedDateValueLabel,
          getDateValue: getDateValue,
          format: format,
          type: type,
          startYear: startYear,
          startMonth: startMonth,
          endYear: endYear,
          endMonth: endMonth,
          startDateDisabled: startDateDisabled,
          endDateDisabled: endDateDisabled,
          disableDate: disableDate,
          optionalStartDateData: optionalStartDateData,
          optionalEndDateData: optionalEndDateData,
          shortestRange: shortestRange,
          longestRange: longestRange,
          year: year,
          month: month,
          onChange: onChange,
          dateData: dateData,
          startData: startData,
          endData: endData,
          hideEndDatePanel: hideEndDatePanel,
          onYearAndMonthChange: this.handleYearAndMonthChange,
          panelWeekStart: panelWeekStart,
          hoverYear: hoverYear,
          hoverMonth: hoverMonth,
          hoverDate: hoverDate,
          changeHoverDate: changeHoverDate
        });
      }

      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, classNameMap.DatePickerDateAreaClassName, true), _defineProperty(_classNames, classNameMap.DatePickerNoFooterClassName, !this.getHasFooter()), _classNames)),
        ref: htmlRef,
        style: style
      }, _react["default"].createElement(_title_panel["default"], {
        locale: locale,
        setLabel: setLabel,
        classNameMap: classNameMap,
        nowDateObject: nowDateObject,
        disabled: titlePanelDisabled,
        chooseMonth: chooseMonth,
        chooseYear: chooseYear,
        year: year || nowDateObject.getFullYear(),
        month: month,
        type: type,
        startYear: startYear,
        startMonth: startMonth,
        endYear: endYear,
        endMonth: endMonth,
        hideEndDatePanel: hideEndDatePanel,
        optionalStartDateData: optionalStartDateData,
        optionalEndDateData: optionalEndDateData,
        onShowChooseMonth: this.handleShowChooseMonth,
        onShowChooseYear: this.handleShowChooseYear,
        onChange: this.handleYearAndMonthChange,
        picker: picker,
        displayedStartYear: displayedStartYear,
        displayedEndYear: displayedEndYear,
        onChangeDisplayedStartYear: onChangeDisplayedStartYear
      }), panelComponent);
    }
  }]);

  return DateArea;
}(_react.PureComponent);

_defineProperty(DateArea, "propTypes", {
  type: _spauiUtils.PropTypes.string,
  year: _spauiUtils.PropTypes.number,
  month: _spauiUtils.PropTypes.number,
  startYear: _spauiUtils.PropTypes.number,
  startMonth: _spauiUtils.PropTypes.number,
  endYear: _spauiUtils.PropTypes.number,
  endMonth: _spauiUtils.PropTypes.number,
  handleYearAndMonthChange: _spauiUtils.PropTypes.func,
  dateData: _spauiUtils.PropTypes.object,
  startData: _spauiUtils.PropTypes.object,
  endData: _spauiUtils.PropTypes.object,
  onChange: _spauiUtils.PropTypes.func,
  startDateDisabled: _spauiUtils.PropTypes.bool,
  endDateDisabled: _spauiUtils.PropTypes.bool,
  disableDate: _spauiUtils.PropTypes.func,
  hoverYear: _spauiUtils.PropTypes.number,
  hoverMonth: _spauiUtils.PropTypes.number,
  hoverDate: _spauiUtils.PropTypes.number,
  changeHoverDate: _spauiUtils.PropTypes.func
});

_defineProperty(DateArea, "defaultProps", {
  startDateDisabled: false,
  endDateDisabled: false
});

var _default = DateArea;
exports["default"] = _default;